import { type FC } from 'react';

import { type Account, getAccountDisplayName } from '../model';

type OrbRedirectPageProps = {
  orbSubscriptionId: string;
  account: Account;
  orbUrl: string;
};

export const OrbInterstitialTestModeRedirect: FC<OrbRedirectPageProps> = ({ orbSubscriptionId, account, orbUrl }) => {
  const accountName = getAccountDisplayName(account);

  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <title>Opening Orb (Test)</title>
        <style>
          {`
            body {
              font-family: system-ui;
              text-align: center;
              padding: 50px;
              background: #f5f5f5;
              color: #333;
            }
            .notice {
              background: white;
              border: 1px solid #ddd;
              border-radius: 8px;
              padding: 30px;
              max-width: 500px;
              margin: 0 auto;
              box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            }
            .countdown {
              font-size: 18px;
              color: #666;
              margin: 20px 0;
            }
            .link {
              color: #0066cc;
              text-decoration: none;
            }
            .link:hover {
              text-decoration: underline;
            }
            .status {
              margin: 10px 0;
              font-size: 14px;
            }
          `}
        </style>
      </head>
      <body>
        <div className="notice">
          <h3>Opening Orb Test Subscription</h3>
          <div id="status" className="status">
            ⚠️ Please manually switch to <strong>test mode</strong> in Orb after redirecting.
            <br />
            <br />
            Account: <strong>{accountName}</strong>
            <br />
            Orb ID: <strong>{orbSubscriptionId}</strong>
          </div>
          <div className="countdown">
            Redirecting in <span id="timer">5</span> seconds...
          </div>
          <p>
            <a href={orbUrl} className="link" id="link">
              Click here to go now
            </a>
          </p>
        </div>
        <script>
          {`
            let countdown = 5;
            const timer = document.getElementById('timer');
            const link = document.getElementById('link');

            // Countdown timer
            const interval = setInterval(() => {
              countdown--;
              timer.textContent = countdown;
              if (countdown === 0) {
                clearInterval(interval);
                window.location.href = "${orbUrl}";
              }
            }, 1000);

            // Allow immediate redirect
            link.addEventListener('click', (e) => {
              e.preventDefault();
              clearInterval(interval);
              window.location.href = "${orbUrl}";
            });
          `}
        </script>
      </body>
    </html>
  );
};
